import { createNamespacedHelpers } from 'vuex';
import NotifyDropdown from '../NotifyDropdown/NotifyDropdown.vue';

import { showConfirmSwal, showConfirmSwalWithCheckbox } from '@/util/swal';
import showToast from '@/util/toast';
import listenChannel from '@/util/socket';

const ANSWER = {
	WAITING: 0,
	REJECTED: 1,
	ACCEPTED: 2,
	OVERWRITE: 3,
}
const modelMapper = createNamespacedHelpers('detector/model');
const notificationMapper = createNamespacedHelpers('notification');
const authMapper = createNamespacedHelpers('global/auth');

const SHARE_ID_REGEX = /Request ID: ([a-zA-Z0-9]+)/
const MODEL_NAME_REGEX = /\bmodel\s+(\S+)\s+with\b/

export default {
	name: 'NotifyLayout',
	components: {
		NotifyDropdown,
	},
	data() {
		return {};
	},
	computed: {
		...authMapper.mapState(['username']),
		...notificationMapper.mapState([
			'notReadedNotificationCount',
			'notificationList',
		]),
		...modelMapper.mapState(['models']),

		translatedSuccess() {
			return this.$t('trainingSuccess');
		},
		
		translatedError() {
			return this.$t('trainingError');
		}
	},

	methods: {
		...notificationMapper.mapActions([
			'retrieveAllNotification',
			'updateNotification',
		]),
		...modelMapper.mapActions(['retrieveModels', 'answerSharingRequest']),
		onToggleDropdown(isUpdateNotify) {
			if (isUpdateNotify) {
				this.updateNotification({ username: this.username });
			}
		},
		
		async onClickMessage(itemData){
			if(itemData.type !== "request"){
				return
			}
			if(this.models.length == 0){
				await this.retrieveModels({ username: this.username });
			}
			if(!this.models.some((model) => model.model_name === itemData.model)){
				const confirm = () => {
					this.sendModelSharingAnswer(ANSWER['ACCEPTED'], itemData.message)
				}
				const decline = () => {
					this.sendModelSharingAnswer(ANSWER['REJECTED'], itemData.message)
				}
				showConfirmSwal(
					{
						title: this.$t('confirmShareModalTitle'),
						text: itemData.message,
						yesButton: this.$t('confirmAccept'),
						noButton: this.$t('confirmDecline'),
					},
					confirm,
					decline
				);
			}
			else {
				const confirm = (isOverwrite) => {
					if(isOverwrite){
						this.sendModelSharingAnswer(ANSWER['OVERWRITE'], itemData.message)
					}
					else{
						this.sendModelSharingAnswer(ANSWER['ACCEPTED'], itemData.message)
					}
				}
				const decline = () => {
					this.sendModelSharingAnswer(ANSWER['REJECTED'], itemData.message)
				}
				let message = itemData.message + "<br>" + this.$t('modelExisted')
				showConfirmSwalWithCheckbox(
					{
						title: this.$t('confirmShareModalTitle'),
						text: message,
						checkboxText: this.$t('allowOverwrite'),
						yesButton: this.$t('confirmAccept'),
						noButton: this.$t('confirmDecline'),
					},
					confirm,
					decline
				);
			}
		},

		async sendModelSharingAnswer(answer, message) {
			let params = {
				share_id: SHARE_ID_REGEX.exec(message)[1],
				answer: answer,
			}
			await this.answerSharingRequest(params)
			await this.retrieveModels({ username: this.username });
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('shareModalShareSuccess'),
			});
			return
		}
	},
	async mounted() {
		const response = await this.retrieveAllNotification({
			username: this.username,
		});
		listenChannel(this._vm, this.username, this.retrieveAllNotification, "notification");
	},
};
